import * as React from 'react';
import { DefaultLayout } from '../../components/DefaultLayout';
import { Seo } from "../../components/Seo";

import { YandexMetrika } from '../../components/YandexMetrika';
import { MailRu } from '../../components/MailRu';
import { TikTok } from '../../components/TikTok';
import { VKPixel } from '../../components/VKPixel';
import { AdvCake } from '../../components/AdvCake';

import { GetCourseWidget } from "../../components/GetCourseWidget";
import { FooterFull } from "../../components/FooterFull";
import { HeaderLogoAndTel } from "../../components/HeaderLogoAndTel";
import { CarouselFullscreen } from "../../components/CarouselFullscreen";
import { Modal } from "../../components/Modal";

import * as main from "./styles/main.module.scss";
import * as screen1 from "./styles/screen1.module.scss";
import * as teach from "./styles/teach.module.scss";
import * as result from "./styles/result.module.scss";
import * as present from "./styles/present.module.scss";
import * as meet from "./styles/meet.module.scss";
import * as invent from "./styles/invent.module.scss";
import * as get from "./styles/get.module.scss";
import * as earn from "./styles/earn.module.scss";
import * as process from "./styles/process.module.scss";
import * as vig from "./styles/vig.module.scss";
import * as example from "./styles/example.module.scss";
import * as mail from "./styles/mail.module.scss";

import earnData from "./data/earnData.json";
const Screen1 = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <header className={screen1.screen1}>
      <div className="container">

        <div className={screen1.breadcrumbs}>
          <a href="/">Главная</a> /
          <a href="/about/advance_for_business/">B2B</a> /
          <span>Партнёрская программа для&nbsp;репетиторов, консультантов и&nbsp;психологов</span>
        </div>

        <div className={screen1.content}>
          <h1 className={screen1.title}>
            Рекомендуйте наши курсы
            и&nbsp;получайте вознаграждение
            за&nbsp;каждого ученика!
          </h1>
          <div className={main.btnWrap}>
            <div className={`${main.blockBtn} ${screen1.btn}`}>
              <button onClick={()=>{setShowModal(true)}} className={main.mainBtn}>Стать партнером</button>
            </div>

            <div className={`${main.blockBtn} ${screen1.btn}`}>
              <a href="https://get.advance-club.ru/cms/system/login?required=true" className={main.mainBtn}>Вход в ЛК партнера</a>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </header>
  );
};
const Teach = () => {
  return (
    <section className={teach.teach}>
      <div className="container">

        <div className="row">
          <div className={`col-12 ${teach.col}`}>
            <div className={`${teach.item} ${teach.item1}`}>
              <h3>Обучайте легко</h3>
              <p className={teach.subtitle}>Хотите работать с&nbsp;детьми, которые любят учиться и&nbsp;умеют это делать?</p>
              <p className={teach.desc}>Порекомендуйте курсы Advance родителям ваших учеников!</p>
              <p className={teach.text}>
                После обучения в&nbsp;Advance школьники в&nbsp;2,5&nbsp;раза быстрее читают, улучшают объем запоминания в&nbsp;2&nbsp;раза
                и&nbsp;внимания в&nbsp;среднем в&nbsp;2&nbsp;раза по&nbsp;данным входного
                и&nbsp;итогового теста
              </p>
            </div>
            <div className={`${teach.photo} ${teach.photo1}`}></div>
          </div>

          <div className={`col-12 ${teach.col}`}>
            <div className={`${teach.photo} ${teach.photo2}`}></div>
            <div className={`${teach.item} ${teach.item2}`}>
              <h3>Репетиторам</h3>
              <p className={teach.text}>
                Курс «Учись&nbsp;Учиться онлайн» поможет школьнику быстро и&nbsp;эффективно осваивать любой материал, самостоятельно выполнять домашние задания, справляться с&nbsp;контрольными и&nbsp;экзаменами. Это отличное дополнение к&nbsp;занятиям с&nbsp;репетитором.
              </p>
              <h3>Консультантам и&nbsp;психологам</h3>
              <p className={teach.text}>Отсутствие мотивации учиться&nbsp;— серьезная проблема для&nbsp;многих родителей. С&nbsp;таким запросом нередко приходят к&nbsp;психологам и&nbsp;консультантам. Но&nbsp;проблема с&nbsp;мотивацией&nbsp;— это только вершина айсберга. Если ребенку будет легко учиться, то мотивация восстановится.</p>
              <p className={teach.desc}>Курс «Учись&nbsp;Учиться онлайн» поможет учиться с&nbsp;удовольствием, восстановить мотивацию ребенка и&nbsp;решить конфликты из-за&nbsp;учебы.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Result = () => {
  return (
    <section className={result.result}>
      <div className="container">

        <div className="row">
          <div className="col-12 col-lg-6">
            <div className={result.item}>
              <h3 className={main.mainTitle}>Что будут делать и чему научатся дети:</h3>
              <ul className={result.list}>
                <li className={result.point}>Дети будут тренировать мнемотехники и&nbsp;учиться переводить умения в&nbsp;навыки.</li>
                <li className={result.point}>Разовьют образное мышление и&nbsp;освоят базовые приемы по&nbsp;запоминанию для&nbsp;эффективной работы памяти.</li>
                <li className={result.point}>Отработают навык выделения главных и&nbsp;опорных пунктов в&nbsp;тексте, освоят прием нелинейного конспектирования с&nbsp;помощью майнд-карт.</li>
                <li className={result.point}>Получат навык работы с&nbsp;карточками и&nbsp;списками, научатся тренировать мозг с&nbsp;помощью «разгонных упражнений» на&nbsp;внимание.</li>
                <li className={result.point}>Научатся переводить информацию из&nbsp;кратковременной памяти в&nbsp;долговременную.</li>
                <li className={result.point}>Освоят элементы быстрого чтения.</li>
                <li className={result.point}>Научатся и&nbsp;самостоятельно проходить по&nbsp;2–3&nbsp;учебника в&nbsp;неделю и&nbsp;готовиться к&nbsp;экзаменам и&nbsp;тестам.</li>
                <li className={result.point}>Научатся и&nbsp;самостоятельно проходить по&nbsp;2–3&nbsp;учебника в&nbsp;неделю и&nbsp;готовиться к&nbsp;экзаменам и&nbsp;тестам.</li>
                <li className={result.point}>
                  <b>Буду уметь:</b>
                  <ul>
                    <li>запоминать через осмысление;</li>
                    <li>работать с&nbsp;определениями, классификациями, формулами;</li>
                    <li>понимать и&nbsp;запоминать основную базу школьных предметов.</li>
                  </ul>
                </li>
                <li className={result.point}>
                  <b>Освоят эффективные технологии обучения:</b>
                  <ul>
                    <li>объединение образов в&nbsp;пары;</li>
                    <li>объединение образов в&nbsp;последовательности;</li>
                    <li>фонетическое кодирование для&nbsp;изучения иностранных слов и&nbsp;терминов;</li>
                    <li>численно-буквенное кодирование для&nbsp;запоминания чисел, дат и&nbsp;событий;</li>
                    <li>метод последовательного приближения для&nbsp;запоминания графической информации.</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <h3 className={main.mainTitle}>Вы увидите результат</h3>
            <div className={`${result.block} ${result.block1}`}>
              <h4>3 тестирования:</h4>
              <p>
                входное, срезовое, итоговое. Каждый ребенок поставит собственный рекорд.
              </p>
            </div>
            <div className={`${result.block} ${result.block2}`}>
              <h4>Дети будут уметь <br/> быстро запоминать:</h4>
              <p>
                даты и&nbsp;события, иностранные слова, определения, любые последовательности данных.
              </p>
            </div>
            <div className={main.blockBtn}>
              <a href="/online/uchis_uchitsya/" className={main.mainBtn}>Подробнее о&nbsp;курсе</a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Present = () => {
  return (
    <section className={present.present}>
      <div className="container">

        <div className={main.mainTitle}>Ознакомьтесь с фрагментом онлайн курса “Учись учиться”</div>
        <div className={present.videoBlock}>
          <div className={present.videoBg}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/EGrw3oQ2vXg?controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>

      </div>
    </section>
  );
};
const Meet = () => {
  return (
    <section className={meet.meet}>
      <div className="container">

        <div className="row">
          <div className="col-12 col-md-8">
            <div className={meet.photo}>
              <div className={meet.text}>
                <p>
                  Приходите и&nbsp;познакомьтесь<br/>с&nbsp;Александром Згода, преподавателями<br/>и&nbsp;технологиями Advance.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Invent = () => {
  return (
    <section className={invent.invent}>
      <div className="container">

        <h2 className={main.mainTitle}>
          Приглашаем вас на&nbsp;бесплатные онлайн мероприятия центра Advance
        </h2>

        <div className="row">
          <div className={`col-12 col-lg-4 col-md-6 ${invent.col}`}>
            <a className={invent.item} href="/webinar/nauchite_detey_uchitsya/" target="_self">
              <p className={invent.theme}>Научите детей учиться</p>
            </a>
          </div>

          <div className={`col-12 col-lg-4 col-md-6 ${invent.col}`}>
            <a className={invent.item} href="/webinar/5_shagov_dlja_rebenka_dz/" target="_self">
              <p className={invent.theme}>Как учить детей удаленно</p>
            </a>
          </div>

          <div className={`col-12 col-lg-4 col-md-6 ${invent.col}`}>
            <a className={invent.item} href="/webinar/kak_zastavit_rebenka_uchitsya/" target="_self">
              <p className={invent.theme}>Как мотивировать ребенка учиться</p>
            </a>
          </div>
        </div>

        <div className={`${main.blockBtn} ${invent.btn}`}>
          <a href="/fulllist/" className={main.mainBtn}>Смотреть полное расписание</a>
        </div>

      </div>
    </section>
  );
};
const Get = () => {
  return (
    <section className={get.get}>
      <div className="container">

        <h2 className={main.mainTitle}>Чего может достичь ваш ребенок?</h2>

        <div className="row">
          <div className={`col-12 col-md-6 ${get.col}`}>
            <div className={get.target}>
              <h3>Цель курса:</h3>
              <ul className={get.list}>
                <li>Ускоренная подготовка к&nbsp;экзаменам</li>
                <li>Сокращение времени на&nbsp;выполнение домашней работы</li>
                <li>Обучение детей из&nbsp;разных регионов</li>
                <li>Увеличение объема запоминания в&nbsp;2-3&nbsp;раза</li>
                <li>Увеличение концентрации внимания в&nbsp;3&nbsp;раза</li>
                <li>Тренировка интеллектуальной выносливсти</li>
              </ul>
            </div>
          </div>

          <div className={`col-12 col-md-6 ${get.col}`}>
            <div className={get.mission}>
              <h3>Миссия курса:</h3>
              <p className={get.subtitle}>Дать инструменты для&nbsp;успешного развития личности во&nbsp;всех сферах жизни</p>
            </div>
            <div className={get.format}>
              <h3>Формат курса:</h3>
              <ul className={get.list}>
                <li>Интерактивный курс </li>
                <li>Занятия от&nbsp;30&nbsp;минут в&nbsp;день </li>
                <li>3&nbsp;уровня сложности </li>
                <li>1,5&nbsp;– 2&nbsp;месяца </li>
                <li>1&nbsp;курс на&nbsp;всех детей в&nbsp;семье </li>
                <li>Короткие обучающие видео </li>
                <li>Отработка на&nbsp;школьном материале</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Earn = () => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return (
    <section className={earn.earn}>
      <div className="container">

        <h2 className={main.mainTitle}>Сколько можно зарабатывать?</h2>

        <div className="row">
          {
            earnData.map((elem, index) => (
              <div className={`col col-12 col-md-6 ${earn.col}`} key={"index"}>
                <button
                  onClick={() => {
                    setFullScreenState({ open: true, selectedSlideIndex: index });
                  }}
                >
                  <img src={elem.imgMinSrc} alt="Начните зарабатывать вместе с Advance: партнерская программа"/>
                </button>
                <p>
                  {elem.title} <br/>
                  <strong>
                    {elem.sum}
                  </strong>
                </p>
              </div>
            ))
          }
        </div>
      </div>

      <CarouselFullscreen
        data={earnData.map((elem) => (
          <img src={elem.imgSrc} alt={elem.title} style={{width: "80%"}} />
        ))}
        open={fullScreenState.open}
        selectedSlideIndex={fullScreenState.selectedSlideIndex}
        onClose={() => {
          setFullScreenState({ open: false, selectedSlideIndex: 0 });
        }}
      />
    </section>
  );
};
const Process = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={process.process} id="process">
      <div className="container">

        <h2 className={main.mainTitle}>Как это работает?</h2>

        <div className="row">
          <div className={`col-12 col-lg-3 col-md-6 ${process.col}`}>
            <div className={process.item}>
              <div className={`${process.num} ${process.num1}`}>1</div>
              <p className={process.desc}>
                Зарегистрируйтесь в&nbsp;нашей партнёрской программе
              </p>
              <div className={`${main.blockBtn} ${process.btn}`}>
                <button className={main.mainBtn} onClick={()=>{setShowModal(true)}}>Регистрация</button>
              </div>
            </div>
          </div>
          <div className={`col-12 col-lg-3 col-md-6 ${process.col}`}>
            <div className={process.item}>
              <div className={`${process.num} ${process.num2}`}>2</div>
              <p className={process.desc}>
                Рекомендуйте участие в&nbsp;наших бесплатных мероприятиях, используя партнёрскую ссылку
              </p>
            </div>
          </div>
          <div className={`col-12 col-lg-3 col-md-6 ${process.col}`}>
            <div className={process.item}>
              <div className={`${process.num} ${process.num3}`}>3</div>
              <p className={process.desc}>
                Система фиксирует регистрации по&nbsp;вашей партнерской ссылке
              </p>
            </div>
          </div>
          <div className={`col-12 col-lg-3 col-md-6 ${process.col}`}>
            <div className={process.item}>
              <div className={`${process.num} ${process.num4}`}>4</div>
              <p className={process.desc}>
                Получаете комиссию
                с&nbsp;каждой оплаты.
                <b>Profit!</b>
              </p>
            </div>
          </div>
        </div>

        <div className={`${main.blockBtn} ${process.btn}`}>
          <a href="https://fs.advance.ru/landing-pages/files/partner_oferta.pdf" className={main.ofertaBtn} target="_blank" rel={"noreferrer"}>
            Договор оферты
          </a>
        </div>

      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Vig = () => {
  return (
    <section className={vig.vig}>
      <div className="container">

        <h2 className={main.mainTitle}>Ваши комиссионые:</h2>

        <div className="row">
          <div className={`col-12 col-md-6 ${vig.col}`}>
            <div className={vig.item}>
              <img src="https://fs.advance.ru/landing-pages/teacher_partner_program/icon/ic1.svg" alt=""/>
              <h3>Ваша комиссия</h3>
              <p>25%</p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${vig.col}`}>
            <div className={vig.item}>
              <img src="https://fs.advance.ru/landing-pages/teacher_partner_program/icon/ic2.svg" alt=""/>
              <h3>Средний чек</h3>
              <p>30&nbsp;000&nbsp;руб.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Example = () => {
  return (
    <section className={example.example}>
      <div className="container">

        <h2 className={main.mainTitle}>Рассмотрим пример:</h2>

        <div className="row">
          <div className={`col-12 col-lg-3 col-md-6 ${example.col}`}>
            <div className={example.block}>
              <div className={example.icon}>
                <img src="https://fs.advance.ru/landing-pages/teacher_partner_program/icon/example_icon1.svg" alt=""/>
              </div>
              <div className={`${example.item} ${example.item1}`}>
                <span className={example.num}>1</span>
                <p className={example.desc}>
                  По&nbsp;вашей ссылке зарегистрировалось 100&nbsp;человек
                </p>
              </div>
            </div>
          </div>

          <div className={`col-12 col-lg-3 col-md-6 ${example.col}`}>
            <div className={example.block}>
              <div className={example.icon}>
                <img src="https://fs.advance.ru/landing-pages/teacher_partner_program/icon/example_icon2.svg" alt=""/>
              </div>
              <div className={`${example.item} ${example.item2}`}>
                <span className={example.num}>2</span>
                <p className={example.desc}>
                  После первого мероприятия, на&nbsp;котором продавался курс стоимостью 39 900&nbsp;руб. заявку оставили 5&nbsp;человек
                </p>
              </div>
            </div>
          </div>

          <div className={`col-12 col-lg-3 col-md-6 ${example.col}`}>
            <div className={example.block}>
              <div className={example.icon}>
                <img src="https://fs.advance.ru/landing-pages/teacher_partner_program/icon/example_icon3.svg" alt=""/>
              </div>
              <div className={`${example.item} ${example.item3}`}>
                <span className={example.num}>3</span>
                <p className={example.desc}>
                  Благодаря слаженной работе отдела продаж, в&nbsp;течение недели 3&nbsp;заявки были оплачены на&nbsp;сумму 119&nbsp;700&nbsp;руб.
                </p>
              </div>
            </div>
          </div>

          <div className={`col-12 col-lg-3 col-md-6 ${example.col}`}>
            <div className={example.block}>
              <div className={example.icon}>
                <img src="https://fs.advance.ru/landing-pages/teacher_partner_program/icon/example_icon4.svg" alt=""/>
              </div>
              <div className={`${example.item} ${example.item4}`}>
                <span className={example.num}>4</span>
                <p className={example.desc}>
                  Ваш заработок составил 25% от&nbsp;этой суммы, то&nbsp;есть 29&nbsp;925&nbsp;руб.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Mail = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={mail.mail}>
      <div className="container">

        <div className={`row ${mail.row}`}>
          <div className={`col-12 col-md-6 ${mail.photo}`}></div>
          <div className="col-12 col-md-6">
            <div className={mail.item}>
              <p className={mail.text}>
                Попадая в&nbsp;нашу рассылку, подписчик получает приглашения на&nbsp;другие тематические мероприятия, что&nbsp;увеличивает вероятность совершения оплаты и&nbsp;получения вами комиссионных
              </p>
              <div className={`${main.blockBtn} ${mail.btn}`}>
                <button className={main.mainBtn} onClick={()=>{setShowModal(true)}}>Стать партнером</button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};

const TITLE = 'Рекомендуйте наши курсы и получайте вознаграждение за каждого ученика! | Центр образовательных технологий Advance';
const DESCRIPTION = 'Рекомендуйте наши курсы и получайте вознаграждение за каждого ученика! | Центр образовательных технологий Advance ✅ Уникальные методики обучения ✅ Эффективное запоминание материала ✅ 100% результат ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=(<GetCourseWidget hash={'00f75d13aaab52f61eb6a503073da2fd406b40a4'} id={'379385'}/>) }) => (
  <DefaultLayout>

    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <div className="container">
      <HeaderLogoAndTel/>
    </div>

    <main style={{ fontFamily: `"Montserrat", sans-serif` }}>
      <Screen1 widget={widget}/>
      <Teach/>
      <Result/>
      <Present/>
      <Meet/>
      <Invent/>
      <Get/>
      <Earn/>
      <Process widget={widget}/>
      <Vig/>
      <Example/>
      <Mail widget={widget}/>
    </main>

    <FooterFull/>

  </DefaultLayout>
);
export default Page;
